import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import EmailBreakdownButton from './EmailBreakdownButton';
import RetakeExamButton from './RetakeExamButton';
// @ts-expect-error Untyped import
import useMediaQuery from '../../../hooks/useMediaQuery';
import { useMostRecentExamAttempt } from '../../exams';
import { useFullTrack, useTrackPendingPracticalExercises } from '../../tracks';
import { HasParentPlaylist, NextPlaylistContent } from '../../playlistContent';
import { getTrackRecommendationsUrl } from '../../../utils/RoutingUtils';
import { device } from '../../../constants/StyledComponentConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ExamFinishedNextSteps = ({
  marginBlockStart = '0',
  marginInlineStart,
  to
}) => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: marginBlockStart,
    marginInlineStart: marginInlineStart,
    children: /*#__PURE__*/_jsx(RouterButton, {
      "data-test-id": "exam-next-steps",
      to: Object.assign({}, location, {
        pathname: to
      }),
      use: to === '/' ? 'tertiary-light' : 'secondary',
      children: to === '/' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.backToLearningTracks"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.next"
      })
    })
  });
};
const ExamFinishedSecondaryButtons = ({
  retake,
  trackId,
  language
}) => {
  const {
    track
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId), language);
  const {
    pendingPracticalExercises
  } = useTrackPendingPracticalExercises(trackId.toString(), language);
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  if (!mostRecentExamAttempt || !track || !pendingPracticalExercises) {
    return null;
  }
  const hasCertification = mostRecentExamAttempt.passed && !pendingPracticalExercises.length;
  const nextSteps = ({
    marginBlockStart,
    marginInlineStart
  }) => /*#__PURE__*/_jsx(HasParentPlaylist, {
    fallback: /*#__PURE__*/_jsx(ExamFinishedNextSteps, {
      marginBlockStart: marginBlockStart,
      marginInlineStart: marginInlineStart,
      to: hasCertification ? getTrackRecommendationsUrl(track.id.toString()) : '/'
    }),
    children: /*#__PURE__*/_jsx(NextPlaylistContent, {
      render: ({
        url
      }) => /*#__PURE__*/_jsx(ExamFinishedNextSteps, {
        marginInlineStart: "300",
        to: url
      }),
      trackId: track.id
    })
  });
  if (isMobile) {
    return /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flexDirection: "column",
        children: [retake && /*#__PURE__*/_jsx(RetakeExamButton, {
          language: language,
          trackId: trackId,
          use: mostRecentExamAttempt.passed ? 'tertiary-light' : 'tertiary',
          withTooltip: true
        }), nextSteps({
          marginBlockStart: '300'
        }), /*#__PURE__*/_jsx(EmailBreakdownButton, {
          language: language,
          marginBlockStart: "300",
          paddingBlock: "200",
          tooltipTitle: !mostRecentExamAttempt.finished && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.exams.finished.breakdownUnavailable"
          }),
          trackId: trackId
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmailBreakdownButton, {
      language: language,
      tooltipTitle: !mostRecentExamAttempt.finished && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.breakdownUnavailable"
      }),
      trackId: trackId
    }), /*#__PURE__*/_jsx(RetakeExamButton, {
      language: language,
      trackId: trackId,
      use: mostRecentExamAttempt.passed ? 'tertiary-light' : 'tertiary',
      withTooltip: true
    }), nextSteps({
      marginInlineStart: '300'
    })]
  });
};
export default ExamFinishedSecondaryButtons;